import { ServiceNames } from "@models/service_enums";
import { Injectable } from "@angular/core";
import { SECURITY_TOKEN_TRANSACTIONS_ROOM, SECURITY_TOKEN_WALLETS_ROOM } from "@helpers/constants";
import { DestructorService } from "@core-services/destructor.service";
import { InitService } from "@core-services/init.service";
import { GetPendingTradesGQLService } from "@gql/offer";
import { AssetWalletService } from "@main-services/wallet/asset_wallet.service";
import { parseList } from "@helpers/functions";
import { SocketService } from "@main-services/socket.service";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { InfoService } from "@core-services/info.service";
import { TranslationService } from "@core-services/translation.service";
import { CryptoTransactionNotifyService } from "@main-services/notify/crypto_transaction.notify.service";
import { WalletsBalancesFacadeService } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.facade.service";
import { Observable, of } from "rxjs";
import { SecurityTokenWallet } from "@models/asset/cryptocoins/wallets/security_token_wallet";
import { SecurityTokenTransaction } from "@models/transaction/security_token_transaction";
import { SecurityToken } from "@models/asset/cryptocoins/currencies/security_token";
import { SecurityTokenService } from "@main-services/currency/securityToken.service";

const name = ServiceNames.SECURITY_TOKEN_WALLET;

@Injectable({
	providedIn: "root"
})
export class SecurityTokenWalletService extends AssetWalletService<
	SecurityTokenWallet,
	SecurityTokenTransaction,
	SecurityToken
> {
	public name: string = ServiceNames.SECURITY_TOKEN_WALLET;

	public TxType = SecurityTokenTransaction;
	public WalletType = SecurityTokenWallet;

	protected transactionSocketRoomName: string = SECURITY_TOKEN_TRANSACTIONS_ROOM;
	protected walletSocketRoomName: string = SECURITY_TOKEN_WALLETS_ROOM;

	public constructor(
		protected currencyService: SecurityTokenService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected initService: InitService,
		protected transactionNotifyService: CryptoTransactionNotifyService,
		protected destructor: DestructorService,
		protected getPendingTradesGQLService: GetPendingTradesGQLService,
		protected walletBalanceFacade: WalletsBalancesFacadeService
	) {
		super(initService, destructor, name, getPendingTradesGQLService);
	}

	public getParseData(wallets): SecurityTokenWallet[] {
		const secTokenRawWallets = wallets?.["attributes"]["cryptocoin"]["security_token"];

		if (!secTokenRawWallets) {
			return [];
		}

		return parseList(secTokenRawWallets["attributes"]["wallets"], SecurityTokenWallet);
	}

	public async cancel(t: SecurityTokenTransaction): Promise<SecurityTokenTransaction> {
		const oldTransaction = new SecurityTokenTransaction();
		Object.assign(oldTransaction, t);
		const call = this.apicallService.deleteRequest(
			"wallet/" + t.getWalletId() + "/transaction/" + t.getId(),
			new ApicallOption(SecurityTokenTransaction)
		);
		return super.cancelSub(call, t, oldTransaction).toPromise();
	}

	public hasWallets$(): Observable<boolean> {
		const hasSecurityTokenWallets = this.list.some((wallet) => wallet.isDefault() && !wallet.isNew());
		return of(hasSecurityTokenWallets);
	}
}
